import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';

import AppLayout from '../../layouts/AppLayout/AppLayout';
import { useLanguage } from '../../context/LanguageProvider/LanguageProvider';
import { NioSection, NioIcon } from '../index';

export default function JasspContentPage({
  titleKey,
  pageTitleKey,
  heroTitleKey,
  leadKey,
  bodyKey,
  children,
}) {
  const { t } = useLanguage();

  return (
    <AppLayout variant={2} titleKey={titleKey || pageTitleKey} rootClass="layout-1">
      <div className="jassp-content-page">
        <section className="jassp-content-hero pt-7 pt-lg-120 pb-6 pb-lg-7">
          <Container>
            <Row className="justify-content-center text-center">
              <Col lg={10} xl={9}>
                <h1 className="jassp-content-hero-title display-4 fw-bold mb-0">
                  {t(heroTitleKey || pageTitleKey)}
                </h1>
                {leadKey ? (
                  <p className="jassp-content-hero-lead fs-18 mb-0 mx-auto mt-4">{t(leadKey)}</p>
                ) : null}
              </Col>
            </Row>
          </Container>
        </section>

        <NioSection className="jassp-hero-light-gap pb-7 pb-lg-120 pt-4 pt-lg-5 bg-light">
          <Container>
            <Row className="justify-content-center">
              <Col lg={10} xl={8}>
                {bodyKey ? <p className="fs-18 text-gray-700 mb-0">{t(bodyKey)}</p> : null}
                {children}
                <div className="text-center pt-5 mt-4">
                  <Link to="/" className="btn btn-outline-primary">
                    <NioIcon name="arrow-left" className="me-2" />
                    {t('portfolio.backHome')}
                  </Link>
                </div>
              </Col>
            </Row>
          </Container>
        </NioSection>
      </div>
    </AppLayout>
  );
}
